import { OFFICE_365_LOGIN_PATH, OFFICE_365_TOKEN_PATH } from '@my-backoffice/app/pages/login/federated/office365/constants/office365-auth.constants';
import { Office365HttpAuthInterceptor } from '@my-backoffice/app/pages/login/federated/office365/interceptors/office365-http-auth.interceptor';
import { AI_API_ACCESS_TOKEN } from '@my-backoffice/app/shared/constants/ai-api-access-token.constants';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly _injector = inject(Injector);

  public constructor(private readonly _router: Router) {}

  private get _httpAuthInterceptor(): Office365HttpAuthInterceptor {
    return this._injector.get(Office365HttpAuthInterceptor);
  }

  public intercept<T>(request: Readonly<HttpRequest<T>>, next: Readonly<HttpHandler>): Observable<HttpEvent<T>> {
    const unauthorizedArray = ['/assets/', '/common-payment', 'COMMON_PAYMENT_BU_MERCHANT_ID_MAPPING', OFFICE_365_LOGIN_PATH, OFFICE_365_TOKEN_PATH];

    if (this._router.url.startsWith('/pay/') || this._router.url.startsWith('/pay-pre-filled/')) {
      unauthorizedArray.push('/payment/adyen/');
    }

    if (request.url.includes('/v1.0/system-event/spec')) {
      request = request.clone({
        setHeaders: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'ai-api-access-token': AI_API_ACCESS_TOKEN,
        },
      });

      return next.handle(request);
    }

    if (!request?.url || unauthorizedArray.some((url: string): boolean => request?.url.includes(url))) {
      return next.handle(request);
    }

    return this._httpAuthInterceptor.intercept(request, next);
  }
}
